import React from "react";
import Menu from '../menu';
import "@whalecloud/fdx-theme-fdx/context-menu.less";

const { SubMenu } = Menu;

interface IOProps {
  getContainer: any
  onChange: any
  options: any
  style: any
}
class ContextMenu extends React.Component<IOProps> {
  private root:any = undefined

  static Option = ({ value, children }) => {
    return [<span>{children}</span>, value];
  };

  static Group = ({ children }) => {
    return children;
  };

  static defaultProps = {
    getContainer: () => document.body,
    onChange: () => { },
  };

  state = {
    visible: false,
  };

  componentDidMount () {
    setTimeout(() => {
      const { getContainer } = this.props;
      const container = getContainer() || document.body;
      container.addEventListener("contextmenu", this._handleContextMenu);
      container.addEventListener("scroll", this._handleScroll);
      document.addEventListener("click", this._handleClick);
    }, 0);
  }

  componentWillUnmount () {
    const { getContainer } = this.props;
    const container = getContainer() || document.body;
    container.removeEventListener("contextmenu", this._handleContextMenu);
    document.removeEventListener("click", this._handleClick);
    container.removeEventListener("scroll", this._handleScroll);
  }

  _handleContextMenu = event => {
    event.preventDefault();

    this.setState({ visible: true });

    const clickX = event.clientX;
    const clickY = event.clientY;
    this.root.style.left = `${clickX + 5}px`;
    this.root.style.top = `${clickY + 5}px`;
  };

  _handleClick = () => {
    const { visible } = this.state;
    if (visible) this.setState({ visible: false });
  };

  _handleScroll = () => {
    const { visible } = this.state;
    if (visible) this.setState({ visible: false });
  };

  renderMenu = (options) => {
    return options.map(item => {
      if(Array.isArray(item.children) && item.children.length!==0) {
        return <SubMenu disabled={item.disable || false} title={item.label} key={item.key}>{this.renderMenu(item.children)}</SubMenu>
      }
      return <Menu.Item disabled={item.disable || false} key={item.key}>{item.label}</Menu.Item>
    })
  }

  render () {
    const { visible } = this.state;
    const { onChange, style } = this.props;
    return (
      (visible || null) && (
        <div
          className="context-menu"
          ref={ref => {
            this.root = ref;
          }}
        >
          <Menu onClick={onChange} style={style ? style : null} mode="vertical">
            {this.renderMenu(this.props.options)}
          </Menu>
        </div>
      )
    );
  }
}

export default ContextMenu;



// WEBPACK FOOTER //
// ./src/components/context-menu/index.tsx